module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("UserLanguage", "Language") ))==null?'':__t)+
'</legend><div><label for="panel-language-input">'+
((__t=( i18n.tc("UserLanguage", "Preferred language:") ))==null?'':__t)+
'</label> <select id="panel-language-input" data-input="panel-language"></select></div></fieldset><fieldset class="button-wrap"><button data-click="language-cancel">'+
((__t=( i18n.tc("UserLanguage", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="language-submit" disabled="disabled">'+
((__t=( i18n.tc("UserLanguage", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
